import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { college, navLinks } from '../mock/data';
import { useStickyScroll } from '../hooks/useStickyScroll';
import Navigation from './header/Navigation';
import MobileMenu from './header/MobileMenu';

export default function Header() {
  const scrolled = useStickyScroll(20);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('Home');

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-[0_6px_24px_-16px_rgba(11,46,110,0.35)]' : 'bg-white'
      }`}
    >
      <div className="container-x flex items-center justify-between py-3">
        <a href="#home" className="flex items-center gap-3">
          <img src={college.logo} alt="Pharmacy College Azamgarh logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-slate-200" />
          <div className="leading-tight">
            <div className="font-extrabold text-[#0B2E6E] text-[17px]">{college.name}</div>
            <div className="text-[11px] font-semibold tracking-[2px] text-slate-500 uppercase">{college.location} · {college.since}</div>
          </div>
        </a>

        <Navigation links={navLinks} active={active} onSelect={setActive} />

        <div className="flex items-center gap-3">
          <a href="#admissions" className="btn-primary hidden md:inline-flex">Admission Open</a>
          <button
            className="lg:hidden p-2 rounded-lg text-[#0B2E6E]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <MobileMenu
          links={navLinks}
          onSelect={(label) => { setActive(label); setOpen(false); }}
          onClose={() => setOpen(false)}
        />
      )}
    </header>
  );
}
